import {connect} from 'formik'

import PriceRangeSelectComponent from './PriceRangeSelect.component'

const PriceRangeSelect = connect(PriceRangeSelectComponent)

export default PriceRangeSelect
